import { Loading } from 'element-ui';
import $ from 'jquery'
import API from '../api/ApiConfig'
export function ajaxGet(interfaceName,methodName,param) {
 return    new Promise((success,fail)=>{
     const loading = Loading.service({
         lock: true,
         text: '正在处理中...',
         spinner: 'el-icon-loading',
         background: 'rgba(0, 0, 0, 0.7)'
     });
         $.ajax({
             type: "GET",
             url: API.ajaxPath,
             async: true,
             data: {
                 interfaceName: interfaceName,
                 methodName: methodName,
                 args: param
             },
             success: function (data) {
                 loading.close();
                 if (data.status === '0') {
                   success(data.result);
                 }else {
                     fail(data.message);
                 }
             },
             error: function () {
                 loading.close();
                 fail("无法连接服务器！请检查网络");
             }
         })
    })
}
export function ajaxPost(interfaceName,methodName,param) {
 return    new Promise((success,fail)=>{
     const loading = Loading.service({
         lock: true,
         text: '正在处理中...',
         spinner: 'el-icon-loading',
         background: 'rgba(0, 0, 0, 0.7)'
     });
         $.ajax({
             type: "POST",
             url: API.ajaxPath,
             async: true,
             data: {
                 interfaceName: interfaceName,
                 methodName: methodName,
                 args: param
             },
             success: function (data) {
                 loading.close();
                 if (data){
                     if (data.status === '0') {
                         success(data.result);
                     }else {
                         fail(data.message);
                     }
                 }
             },
             error: function () {
                 loading.close();
                 fail("无法连接服务器！请检查网络");
             }
         })
    })
}

//后台请求使用，不锁界面
export function ajaxPostNotLock(interfaceName,methodName,param) {
 return    new Promise((success,fail)=>{
         $.ajax({
             type: "POST",
             url: API.ajaxPath,
             async: false,
             data: {
                 interfaceName: interfaceName,
                 methodName: methodName,
                 args: param
             },
             success: function (data) {
                 if (data){
                     if (data.status === '0') {
                         success(data.result);
                     }else {
                         fail(data.message);
                     }
                 }
             },
             error: function () {
                 fail("无法连接服务器！请检查网络");
             }
         })
    })
}


export function getRootPath () {
    //获取当前网址，如： http://localhost:8088/test/test.jsp
    var curPath = window.document.location.href;
    //获取主机地址之后的目录，如： test/test.jsp
    var pathName = window.document.location.pathname;
    var pos = curPath.indexOf(pathName);
    //获取主机地址，如： http://localhost:8088
    var localhostPath = curPath.substring(0, pos);
    //获取带"/"的项目名，如：/test
    var projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);
    if (projectName){
        return (localhostPath + projectName);
    } else {
        return (localhostPath + projectName+"/portal");

    }
}



// WEBPACK FOOTER //
// ./src/util/AjaxhttpRequest.js